import * as React from 'react';
import getImageUrl from 'utils/getImageUrl';
import { numFormat } from 'utils/numFormat';
import SimpleImage from 'components/Common/Image/SimpleImage';
import ProductAvailabilityMessage from 'components/ProductAvailabilityMessage/ProductAvailabilityMessage';
import ProductRatingWidget from 'components/ProductRatingWidget/ProductRatingWidget';
import StringWidget from 'components/StringWidget';
import PriceWidget from 'components/PriceWidget';
import styles from './ProductShareMessage.css';
import MessageMeta, { MessageMetaTheme } from 'components/MessageMeta/MessageMeta';
import { NLink } from 'components/Common/ALink/ALink.js';
class ProductShareMessage extends React.Component {
    render() {
        const { isReceivedMessage, messageContent, messageStatus, timeStamp } = this.props;
        if (!messageContent) {
            return null;
        }
        const { baseUrl, imageUrl, title, pricing, rating, isOffer, buyability, sellingPrice } = messageContent;
        return (<NLink to={baseUrl}>
				<div className={styles['shared-product-container']}>
					<div className={styles['product-card']}>
						<div className={styles['product-image']}>
							<SimpleImage src={getImageUrl(imageUrl, '256', '70')} size={112}/>
							<ProductAvailabilityMessage {...buyability} className={styles['product-buyability']}/>
						</div>

						<div className={styles['title']}>{title}</div>
						{pricing ? (<PriceWidget pricing={pricing} containerClassName={styles['price']}/>) : (sellingPrice && (<div className={styles['price']}>
									<div className={styles['selling-price']}>{`₹${numFormat(Number(sellingPrice))}`}</div>
								</div>))}
						<ProductRatingWidget product={{ value: { rating } }} view={'minimal'}/>
						{isOffer && (<div className={styles['on-offer']}>
								<StringWidget strKey="chatOffer"/>
							</div>)}

						<MessageMeta lastReadMessageTimestamp={this.props.lastReadMessageTimestamp} lastDeliveredMessageTimestamp={this.props.lastDeliveredMessageTimestamp} theme={MessageMetaTheme.DARK} messageStatus={messageStatus} isReceivedMessage={isReceivedMessage} timeStamp={timeStamp}/>
					</div>
				</div>
			</NLink>);
    }
}
export default ProductShareMessage;
